import { useI18n } from "vue-i18n";
import { localePath, Locale } from "../utils/locale";

/** Links in the current language: lp("/connectera") → "/en/connectera" when reading in English. */
export function useLocalePath() {
  const { locale } = useI18n();
  return (basePath: string) => localePath(basePath, locale.value as Locale);
}
